<template>
  <div @keyup="checkEnterKeyAndSignIn"  class="main-container">
    <div class="main-login-container">
      <div class="login-container">
        <img 
          src="../assets/logo-pemex-og.png" 
          alt="logo pemex"
          class="logo"
        >
        <div>
          <h1>Bienvenido</h1>
          <p>
            Por favor introduce tus credenciales para iniciar sesión
          </p>
        </div>
        <v-form>
          <v-text-field
            label="Usuario"
            :rules="[rules.userRequired]"
            class="input"
            v-model="username"
            outlined
            :error="this.userMissing"
            @input="this.verifyUsername"
            color="#008B52"
            ref="passwordInput"
            
          >
          </v-text-field>
          <v-text-field
            label="Contraseña"
            @input="this.verifyPassword"
            :rules="[rules.passwordRequired]"
            class="input password"
            v-model="password"
            outlined
            :error="this.passwordMissing"
            color="#008B52"
            :append-icon="iconBlind ? 'mdi-eye' : 'mdi-eye-off'"
            :type="iconBlind ? 'text' : 'password'"
            @click:append="iconBlind = !iconBlind"
            name="input-10-1"
          >
          </v-text-field>
          <v-btn
            class="ma-2 button"
            color="#008B52"
            x-large
            @click="this.signIn"
          >
          Iniciar sesión
          </v-btn>
        </v-form>
        <span>
          {{errorMessage}}
        </span>
      </div>
    </div>
    <div class="background">
      <div class="gradient-on-background">
      </div>
    </div>
  </div>
</template>
<script>
import { logIn } from '../utils/serverRequests'
import { configEnv } from '../config/config'
export default {
  name: 'Login',
  mounted() {
    this.focusUserInput()
  },
  data() {
    return {
      iconBlind: false,
      rules: {
        userRequired: value => !!value || 'Usuario requerido',
        passwordRequired: value => !!value || 'Contraseña requerida'
      },
      username: '',
      password: '',
      userMissing: false,
      passwordMissing: false,
      errorMessage: ''
    }
  },
  methods: {
    verifyUsername(e) {
      this.userMissing = e ? false : true
      this.errorMessage = ''
    },
    verifyPassword(e) {
      this.passwordMissing = e ? false : true
      this.errorMessage = ''
    },
    focusUserInput() {
      this.$refs.passwordInput.focus()
    },
    checkEnterKeyAndSignIn(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.signIn()
      }
    },
    signIn(){
      let { username, password} = this
      this.userMissing = username ? false : true
      this.passwordMissing = password ? false : true
      if(!username || !password) return
      logIn({ username, password })
        .then(response => {
          let data = response.data
          if(data.jwt) {
            window.localStorage.setItem(configEnv.tokenKey, data.jwt)
            window.localStorage.setItem(configEnv.userDataKey, JSON.stringify(data.user))
            this.$store.commit('definedUserData', data.user)
            this.$store.commit('definedJwt', data.jwt)
            this.$router.push(`/${data.user.permissions[0]}`)
          }
        })
        .catch(error => {
          if(error.response.status === 401) {
            this.errorMessage = "Usuario o contraseña incorrectos"
          } else {
            this.errorMessage = "Por favor intentelo de nuevo. Error interno"
          }
        }) 
    },

  }
}

</script>
<style scoped>
span {
  color: red
}
.main-container {
  width: 100%;
  height: 100%;
  display: flex;
}
.login-container {
  width: 80%;
  min-width: 60%;
  display: flex;
  align-content: center;
  flex-direction: column;
  align-items: center;
}
.button {
  color: white !important;
  min-width: 200px;
  width: 325px;
}
h1 {
  font-size: 40px;
  margin-bottom: 0px;
}
p {
  margin-bottom: 30px !important;
}
.input {
  min-width: 200px;
  width: 344px;
  margin-bottom: 20px !important;
}
.password {
  margin-bottom: 20px !important;
}
.main-login-container {
  width: 40%;
  height: 100%;
  background-color: #FBF7F7;
  display: flex;
  justify-content: center;
  align-items: center;
}
.background {
  width: 60%;
  height: 100%;
  background-image: url(../assets/oil-rigs.svg);
  background-repeat: no-repeat;
  background-size: cover;
}
.gradient-on-background {
  width: 100%;
  height: 100%;
  z-index: 1;
  background: linear-gradient(90deg, #FBF7F7 0%, rgba(196, 196, 196, 0) 100%);
}
.logo {
  min-width: 150px;
  width: 30%;
  margin-bottom: 20px;
}
@media only screen and (max-width: 1200px) {
  .logo {
    margin-bottom: 0px;
  }
  .password {
    margin-bottom: 0px !important;
  }
  p {
    margin-bottom: 10px !important;
  }
}
</style>
